/* @flow */

import * as React from 'react';
import Notification from './Notification';

type Props = {
  afterCond: boolean,
  beforeCond: boolean,
  children: any,
  confirmText?: string,
  onConfirm?: () => void,
  persist?: boolean,
  type: 'danger' | 'info' | 'success' | 'warning'
};

type State = {
  displayNotification: boolean
};

class NotificationHandler extends React.Component<Props, State> {
  props: Props;

  state: State = {
    displayNotification: false
  };

  static defaultProps = {
    confirmText: undefined,
    onConfirm: undefined,
    persist: false
  };

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    const { beforeCond } = this.props;

    if (beforeCond && nextProps.afterCond) {
      this.setState({
        displayNotification: true
      });
    }
  }

  hide = () => {
    this.setState({
      displayNotification: false
    });
  };

  render() {
    const { children, confirmText, persist, onConfirm, type } = this.props;
    const { displayNotification } = this.state;

    if (!displayNotification) {
      return null;
    }

    return (
      <Notification
        type={type}
        confirmText={confirmText}
        onConfirm={onConfirm}
        onClose={this.hide}
        persist={persist}
      >
        {children}
      </Notification>
    );
  }
}

export default NotificationHandler;
